import { render } from "./MessageStoriesView.vue?vue&type=template&id=26ddbf7e&scoped=true"
import script from "./MessageStoriesView.vue?vue&type=script&lang=js"
export * from "./MessageStoriesView.vue?vue&type=script&lang=js"

import "./MessageStoriesView.vue?vue&type=style&index=0&id=26ddbf7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ddbf7e"]])

export default __exports__